import { Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core';
import React from 'react'

import { CarouselImagen } from './CarouselImagen';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { deslogueoPacienteSala, ingresoPacienteSala } from '../../../actions/hce/hceTeleconsultaActions';
import { useState } from 'react';
import { startAlerta } from '../../../actions/ui/alertas';


const optionsfecha = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
};

export const SalaEsperaAfiliado = (props) => {

    const prescipcion = 'Prescripciones: en el caso de que el profesional deba realizar una prescripción, recibirás la receta electrónica por correo electrónico y podrás dirigirte a nuestras farmacias adheridas y mostrarla a través de cualquier dispositivo móvil.'
    const { dataAfiliado, turnoTeleconsulta, turnosProximos } = useSelector((state) => state.hce);
    const [idConexion, setIdConecion] = useState("");
    const [medicoEnSala, setMedicoEnSala] = useState(false);
    const [idAgenda, setIdAgenda] = useState("");

    const dispatch = useDispatch();
    const baseUrl = process.env.REACT_APP_URL;
    const baseUrlT = process.env.REACT_APP_URL_BASE;


    let nombre = "Paciente";

    useEffect(() => {
        if (turnoTeleconsulta && turnoTeleconsulta.length > 0 && dataAfiliado?.idAfiliado > 0 && idConexion !== "") {
            const data = {
                idAfiliado: dataAfiliado?.idAfiliado,
                idEfector: turnoTeleconsulta?.map(turno => turno.idEfector),
                connectionId: idConexion
            }
            dispatch(ingresoPacienteSala(data));
        }
    }, [turnoTeleconsulta, idConexion]);



    useEffect(() => {
        const connection = new HubConnectionBuilder()
            .withUrl(`${baseUrl}/hubs/logs/teleconsulta`)
            .withAutomaticReconnect()
            .build();

        connection.start()
            .then(result => {
                console.log('Connected!');
                const id = connection.connection.connectionId;
                setIdConecion(id)
            })
            .catch(error => {
                console.error('Error connecting:', error);
            });
        connection.on('IniciarChatAfiliado', (messages) => {
            dispatch(
                startAlerta(
                    'Medico en sala',
                    'success',
                    'Comando Exitoso',
                ),
            );
            setIdAgenda(messages);
            setMedicoEnSala(true)
        })

        return () => {
            connection.stop();
        }
    }, [baseUrl, dispatch]);


    useEffect(() => {
        // Guarda los datos en localStorage cuando cambien
        if (dataAfiliado && idConexion && turnoTeleconsulta) {
            localStorage.setItem("dataAfiliado", JSON.stringify(dataAfiliado));
            localStorage.setItem("idConexion", idConexion);
            localStorage.setItem("turnoTeleconsulta", JSON.stringify(turnoTeleconsulta));
        }
    }, [dataAfiliado, idConexion, turnoTeleconsulta]);
    
    useEffect(() => {
        const handleBeforeUnload = () => {
            const dataAfiliadoStorage = JSON.parse(localStorage.getItem("dataAfiliado"));
            const idConexionStorage = localStorage.getItem("idConexion");
            const turnoTeleconsultaStorage = JSON.parse(localStorage.getItem("turnoTeleconsulta"));
    
            const data = {
                idAfiliado: dataAfiliadoStorage?.idAfiliado,
                connectionId: idConexionStorage,
                idEfector: turnoTeleconsultaStorage?.map(turno => turno.idEfector),
            };
            dispatch(deslogueoPacienteSala(data));
            
          
        };
    
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("unload", handleBeforeUnload);
    
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("unload", handleBeforeUnload);
        };
    }, [dispatch]);


    return (
        <React.Fragment>
            <Grid container direction="row" alignItems="center" spacing={2} style={{ padding: "2rem" }}>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    style={{ paddingLeft: "5rem", paddingRight: "5rem" }}
                >
                    <Typography variant="h5" color="primary" style={{ marginTop: "1rem" }}>HOLA, {dataAfiliado?.nombreApellido}</Typography>
                    <Typography variant="body2" color="primary" style={{ marginTop: "1rem", fontSize: "1rem" }}>Se encuentra en la sala espera, aguarde a ser llamado</Typography>
                    {Array.isArray(turnoTeleconsulta) && turnoTeleconsulta?.length > 0 ? (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: '10%' }}>Fecha</TableCell>
                                    <TableCell style={{ width: '10%' }}>Hora</TableCell>
                                    <TableCell style={{ width: '30%' }}>Profesional</TableCell>
                                    <TableCell style={{ width: '30%' }}>Especialidad</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {turnoTeleconsulta.map((turno, index) => {
                                    return (
                                        <TableRow>
                                            <TableCell>{new Date(turno?.fecha).toLocaleString('es', optionsfecha)}</TableCell>
                                            <TableCell>{turno?.hora}</TableCell>
                                            <TableCell>{turno?.nombreMedico}</TableCell>
                                            <TableCell>{turno?.descripcionEspecialidad}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography variant="body2" color="secondary" style={{ marginTop: "1rem" }} >
                            NO SE REGISTRAN PRÓXIMOS TURNOS.
                        </Typography>
                    )}
                    {medicoEnSala && (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                style={{
                                    fontSize: '0.8rem',
                                    marginTop: "1rem"
                                }}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    const url = `${baseUrlT}/afiliado/salaTelemedicina?nombre=${nombre}&idAgenda=${idAgenda}`;
                                    const newTab = window.open(url, '_blank', 'noopener,noreferrer');
                                    console.log(newTab)
                                }}
                            >
                                Iniciar Teleconsulta
                            </Button>
                        </div>
                    )}
                    <Typography align="center" variant="h6" color="primary" style={{ marginTop: "1rem" }}>Tus próximos turnos</Typography>

                    {Array.isArray(turnosProximos) && turnosProximos?.length > 0 ? (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: '10%' }}>Fecha</TableCell>
                                    <TableCell style={{ width: '10%' }}>Hora</TableCell>
                                    <TableCell style={{ width: '30%' }}>Profesional</TableCell>
                                    <TableCell style={{ width: '30%' }}>Especialidad</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {turnosProximos.map((turno, index) => {
                                    return (
                                        <TableRow>
                                            <TableCell>{new Date(turno?.fecha).toLocaleString('es', optionsfecha)}</TableCell>
                                            <TableCell>{turno?.hora}</TableCell>
                                            <TableCell>{turno?.nombreMedico}</TableCell>
                                            <TableCell>{turno?.descripcionEspecialidad}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography variant="body2" color="secondary" style={{ marginTop: "1rem" }} >
                            NO SE REGISTRAN PRÓXIMOS TURNOS.
                        </Typography>
                    )}

                    <Typography variant="body2" color="primary" style={{ marginTop: "1rem", fontSize: "1rem" }}>{prescipcion}</Typography>


                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    style={{ paddingLeft: 1 }}
                >
                    <CarouselImagen />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
